import React from 'react';
import { clsPrefix } from '../const';
import { CnStatisticTitleBaseProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticBaseTitle({
  children,
  title,
  tip,
  tag,
  CnFormat,
  CnStatusTag,
  onClick
}: CnStatisticTitleBaseProps) {
  return (
    <div className={`${clsPrefix}-title`} onClick={onClick}>
      {title ? <CnFormat value={{ text: title }} format="CnFormatText" /> : null}
      {tip ? <CnFormat type="help" format="CnFormatIcon" {...{ tooltip: tip }} /> : null}
      {tag ? (
        <CnStatusTag type="secondary" status="invalid" size="small">
          {tag}
        </CnStatusTag>
      ) : null}
      {children}
    </div>
  );
}

export default CnStatisticBaseTitle;
